<!--
  创建时间：2023/7/27 16:30
  创建人：toyehuang
  文件描述：HeadSearch
-->
<template>
  <div
    v-if="!$route.meta.noSearch"
    class="f-b-c header-search-view el-no-border fb-14"
  >
    <el-select
      v-model="searchType"
      placeholder="请选择"
      class="primary-selected bgf5 fb-14"
    >
      <el-option
        v-for="item in options"
        :key="item[optionConfig.CODE]"
        :label="item[optionConfig.LABEL]"
        :value="item[optionConfig.CODE]"
      />
    </el-select>
    <el-input
      v-model="searchValue"
      placeholder="请输入关键字搜索..."
    />
    <el-button
      type="primary"
      class="fill-h my-search-btn"
      @click="search"
    >搜索</el-button>
  </div>
</template>

<script>
import {
  getConstantDic,
  SEARCH_INPUT_OPTIONS_TYPES,
  SELECT_OPTION_CONFIG
} from "@/utils/constant";
import { mapGetters } from "vuex";

export default {
  name: "HeadSearch",
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
  },
  data() {
    return {
      searchType: "",
      searchValue: "",
      options: getConstantDic(SEARCH_INPUT_OPTIONS_TYPES),
      optionConfig: SELECT_OPTION_CONFIG
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["site", "allMenusList"]),
    searchPath() {
      const searchItem = this.allMenusList.find(m => m.code === this.searchType) || {}
      return searchItem.path
    }
  },
  watch: {
    searchType(v) {
      sessionStorage.setItem("searchType", v)
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.searchValue = this.$route.query.title || ""
    this.searchType = sessionStorage.getItem("searchType") || SEARCH_INPUT_OPTIONS_TYPES.BIDDING_NOTICE[SELECT_OPTION_CONFIG.CODE]
  },
  // 方法集合
  methods: {
    search() {
      const keyword = this.searchValue;
      this.searchValue = "";
      const route = this.$router.resolve({
        path: this.searchPath,
        query: {
          title: keyword
        }
      });
      window.open(route.href, "_self")
    }
  }
};
</script>

<style scoped lang="scss">
.header-search-view {
  width: 460px;
  height: 40px;
  border: 2px solid $--color-primary;
  ::v-deep{
    .el-input, .el-input__inner{
      height: 36px;
      border: none;
    }
  }
}
.my-search-btn {
  width: 100px;
  font-size: 14px;
  padding: 0;
  flex-shrink: 0;
  border-radius: 0;
}
</style>
